/* eslint-disable react/prop-types */
import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../components/button/MyButton';

import './LoginInform.css';

const LoginInform = function (props) {
  const { t } = useTranslation();
  const { steep, setSteep, setOpen, msg } = props;

  const handleNext = () => {
    setSteep(steep + 1);
    setOpen(false);
  };
  return (

      <div
        className="col-sm-12"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: 100,
          marginBottom: 100,
        }}
      >
        <img src="./img/checkOk.svg" alt="ok" className="img-category-check" />
        <h5 className="text-3" style={{ marginTop: 20 }}>
          {t('CodSendBy')} {msg}
        </h5>
        <Button
          style={{
            marginTop: 20,
            marginBottom: 20,
            marginRight: 20,
            height: 40,
            width: 129,
          }}
          onClick={handleNext}
          label="OK"
        />
      </div>

  );
};

export default LoginInform;
